import * as React from 'react';
import {
	makeStyles,
	Fab,
	Grid,
	Paper,
	Dialog,
	DialogTitle,
	Button,
	DialogContentText,
	DialogActions,
	DialogContent,
	Typography,
} from '@material-ui/core';
import { IframeComponent } from './IframeComponent';
import { stores } from '../store';
import { observer } from 'mobx-react-lite';
import RecentlyOpenedJobs from '../components/Ask/RecentlyOpenedJobs';
import { faCommentAltTimes } from '@fortawesome/pro-light-svg-icons';
import { Icon } from '@mitie/material-ui-extensions';
import { faCommentAltTimes as faCommentAltTimesSolid } from '@fortawesome/pro-solid-svg-icons';
import { PageTitle } from 'components/Design';

const useStyles = makeStyles(theme => ({
	frameContainer: {
		margin: '10px 25px',
		width: '100%',
		overflowX: 'auto',
	},
	paper: {
		display: 'flex',
		height: '100%',
		overflow: 'auto',
		flexDirection: 'column',
		boxShadow: 'none !important',
		width: '100%',
		paddingLeft: '20px',
		marginTop: '4px',
		'@media (max-width:768px)': {
			paddingLeft: '10px',
		},
	},
	esmeContainer: {
		width: '100%',
		minWidth: '700px',
		height: '100%',
	},
	esmeCloseIcon: {
		width: '46px',
		height: '46px',
		display: 'none',
		backgroundColor: '#007DBA !important',
		boxShadow: 'none',
		'&:hover': {
			backgroundColor: '#14A0D6 !important',
			'& > * svg': {
				color: '#FFFFFF',
				display: 'flex',
			},
		},
		'& > * svg': {
			color: '#FFFFFF',
			display: 'flex',
			fontSize: '24px !important',
		},
	},
	alignStyle: {
		'& .MuiTypography-h6': {
			font: 'normal normal normal 24px/12px Roboto',
			color: '#002855',
			height: '29px',
			marginTop: '10px',
		},
	},
	textMargin: {
		textAlign: 'center',
	},
	jobsDisplay: {
		height: '850px',
		width: '512px',
		[theme.breakpoints.down('md')]: {
			width: '312px',
		},
	},
	esmeWithJobs: {
		width: 'calc(100% - 522px)',
		[theme.breakpoints.down('md')]: {
			width: 'calc(100% - 332px)',
		},
	},
	esmeWindow: {
		width: '100%',
	},
	closeIcon: {
		width: '40px',
		height: '40px',
		'& > * svg': {
			color: theme.palette.background.paper,
			display: 'flex',
		},
	},
	ActionButtons: {
		backgroundColor: '#007DBA !important',
		color: '#FFFFFF',
		marginLeft: '2px !important',
		'&:hover': {
			backgroundColor: '#56b1df !important',
			color: '#FFFFFF',
		},
	},
	ActionButtons2: {
		color: '#007DBA',
		border: '1px solid #007DBA',
		'&:hover': {
			backgroundColor: '#007DBA',
			color: '#FFFFFF',
			border: '1px solid #007DBA',
		},
	},
	dialogStyle: {
		'& .MuiDialog-paper': {
			margin: '0px',
		},
		'& .MuiDialogContent-root': {
			padding: '0px',
		},
		'& .MuiDialog-paperScrollPaper': {
			maxHeight: 'unset',
			borderRadius: '16px',
			boxShadow: '0px 3px 6px #00000029',
			height: '157px',
		},
		'& .MuiDialogTitle-root': {
			padding: '16px 29px 0px 30px !important',
		},
		'& .MuiDialogContentText-root': {
			marginLeft: '24px',
			font: 'normal normal normal 18px/24px Roboto',
			color: '#565A5C',
			marginBottom: '6px',
			marginTop: '-5px',
		},
	},
}));

const ChatBot: React.FunctionComponent = observer(() => {
	const { route } = React.useContext(stores.context.routes);
	const user = React.useContext(stores.context.user);
	const classes = useStyles();
	const routes: any = React.useContext(stores.context.routes);
	const [hover, sethover] = React.useState(false);
	const [esmeDialogOpen, setEsmeDialogOpen] = React.useState(false);
	const handleClickClose = () => {
		setEsmeDialogOpen(false);
	};

	const handleCloseChat = () => {
		// inform Esme before navigation
		resetChatbot();
		// dela 0.5 second so Esme if in Live chat can inform Mitel agent about user leaving chat
		setTimeout(() => {
			setEsmeDialogOpen(false);
			routes.navigate({ name: 'chatbot' }, { clearParams: true });
			routes.testval = false;
		}, 500);
	};
	window.addEventListener(
		'message',
		event => {
			if (event.data === 'firstmessage') {
				routes.testval = true;
			} else {
				routes.testval = false;
			}
		},
		false,
	);

	const resetChatbot = () => {
		const iframeEl: any = document.getElementById('myframe');
		iframeEl.contentWindow.postMessage('reset', '*');
	};
	const esmeUrl = process.env.REACT_APP_ESME_URL;
	const site = user.esmesite.find(({ Id }: any) => Id === user?.currentSiteId);

	// allows esme to send messages back to aria
	window.addEventListener('message', (event: any) => {
		if (event.origin.replace('/', '') != esmeUrl?.replace('/', '')) {
			return;
		}
		switch (event.data) {
			case 'TABBED_OUT':
				// when tabbing from esme should returns to aria not the browser
				var focusable = document.querySelectorAll('button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
				var firstFocusable: HTMLInputElement = focusable[0] as HTMLInputElement;
				firstFocusable.focus();
				break;
		}
	});

	return (
		<>
			<div className={classes.frameContainer}>
				{site?.EsmeClientId ? (
					<Grid container spacing={1} key={site.EsmeClientId} className={classes.esmeContainer}>
						<Grid className={user.CafmId === 1 ? classes.esmeWithJobs : classes.esmeWindow}>
							<Paper className={classes.paper}>
								<Grid container>
									<PageTitle>Job Request Chat</PageTitle>
									<Grid item container xs={4} sm={4} justify="flex-end">
										<Fab
											color="primary"
											aria-label="add"
											onMouseOver={() => sethover(true)}
											onMouseOut={() => sethover(false)}
											className={classes.esmeCloseIcon}
											onClick={() => {
												setEsmeDialogOpen(true);
											}}
										>
											{hover ? <Icon icon={faCommentAltTimesSolid} /> : <Icon icon={faCommentAltTimes} />}
										</Fab>
									</Grid>
								</Grid>
								<Grid container style={{ height: '100%' }}>
									<Grid item xs={12}>
										{route.params.srId === undefined ? (
											<IframeComponent
												iframeSrc={`${esmeUrl}?subChannel=ar02&header=off`}
												height="450px"
												width="100%"
												token={user.token}
												clientId={site.EsmeClientId}
											/>
										) : (
											<IframeComponent
												iframeSrc={
													route.params.jobApproval
														? `${esmeUrl}?subChannel=ar02&header=off&servicerequest=${route.params.srId}&approvemyjobs=x`
														: `${esmeUrl}?subChannel=ar02&header=off&servicerequest=${route.params.srId}`
												}
												height="450px"
												width="100%"
												token={user.token}
												clientId={site.EsmeClientId}
											/>
										)}
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						{user.CafmId === 1 && (
							<Grid item className={classes.jobsDisplay}>
								<RecentlyOpenedJobs />
							</Grid>
						)}
					</Grid>
				) : site && site?.EsmeClientId === null ? (
					<>
						<div className={classes.textMargin}>
							<Typography variant="subtitle2">Chatbot is not available for this site.</Typography>
						</div>
					</>
				) : (
					<>{/* Loading Site Data */}</>
				)}
			</div>
			<Dialog
				style={{ margin: 'auto', maxWidth: '487px' }}
				className={classes.dialogStyle}
				open={esmeDialogOpen}
				onClose={handleClickClose}
			>
				<DialogContent>
					<DialogTitle id="form-dialog-title" className={classes.alignStyle}>
						Are you sure you want to leave the chat?
					</DialogTitle>
					<DialogContentText>
						Please take a note of the Service Request reference if given, this chat will end and be deleted.
					</DialogContentText>
					<DialogActions>
						<Button
							title="Return to Chat"
							size="medium"
							color="primary"
							className={classes.ActionButtons2}
							variant="outlined"
							onClick={handleClickClose}
						>
							Return to Chat
						</Button>
						<Button
							title="Close Chat"
							size="medium"
							color="primary"
							className={classes.ActionButtons}
							variant="contained"
							onClick={handleCloseChat}
						>
							Close Chat
						</Button>
					</DialogActions>
				</DialogContent>
			</Dialog>
		</>
	);
});

export default ChatBot;
